<template>
  <FriedModal :size="ModalSize.XLarge" closable @close="$emit('close')">
    <template #header>
      <FriedModalHeader :header="header" />
    </template>
    <PlansInformation class="plans-information" />
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          :button-type="ButtonType.Secondary"
          data-external="subscription-modal-not-now-btn"
          @click="$emit('close')"
          >{{ t('trial_plan_button_not_now') }}
        </FriedButton>
        <FriedButton
          :color="RainbowColor.Lilac"
          data-external="subscription-modal-contact-btn"
          @click="openChat"
        >
          <template #leftIcon>
            <FriedIcon icon="publish" />
          </template>
          {{ t('contact-us') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType, RainbowColor, ModalSize } from '@getaccept/fried-tofu';
import { useIntercomChat } from '@getaccept/lib-shared/src/composables/intercom-chat.composable';
import { storeToRefs } from 'pinia';
import { useSubscriptionStore } from '../store/subscription.store';
import PlansInformation from './PlansInformation.vue';

export default defineComponent({
  components: { PlansInformation },
  emits: ['close'],
  setup(_, { emit }) {
    const { openChat: openIntercomChat } = useIntercomChat();
    const { daysLeft } = storeToRefs(useSubscriptionStore());
    const header = computed(() => `${t('trial_plan_days_left')} ${daysLeft.value}`);

    const openChat = () => {
      openIntercomChat();
      emit('close');
    };

    return {
      RainbowColor,
      header,
      t,
      openChat,
      ButtonType,
      ModalSize,
    };
  },
});
</script>
<style lang="scss" scoped>
.plans-information {
  margin-top: var(--spacing-150);
}
</style>
